export const NUMBER_OF_LIMIT_INFINITY = 999999;
